import React from "react";
import { Routes, Route, Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import AuthProvider, { useAuth } from "./components/AuthProvider";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Payment from "./components/Payment";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Admin from "./components/Admin";
import { useEffect, useState } from "react";
import { db, auth } from "./firebase";
import { doc, getDoc } from "firebase/firestore";

function PrivateRoute({ children }) {
  const { currentUser } = useAuth() || {};
  const location = useLocation();
  return currentUser ? children : <Navigate to="/login" state={{ from: location }} replace />;
}

function AppContent() {
  const [isAdmin, setIsAdmin] = useState(false);
  const { currentUser } = useAuth() || {};
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) return;
    const checkAdmin = async () => {
      const userRef = doc(db, "users", currentUser.uid);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists() && userSnap.data().role === "admin") {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    };
    checkAdmin();
  }, [currentUser]);

  const handleLogout = async () => {
    await auth.signOut();
    navigate("/login");
  };

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Lead Scraper
          </Typography>
          <Button color="inherit" component={Link} to="/">Dashboard</Button>
          <Button color="inherit" component={Link} to="/payment">Payment</Button>
          {isAdmin && (
            <Button color="inherit" component={Link} to="/admin">Admin</Button>
          )}
          {currentUser && (
            <Button color="inherit" onClick={handleLogout}>Logout</Button>
          )}
        </Toolbar>
      </AppBar>
      <Routes>
        <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/payment" element={<PrivateRoute><Payment /></PrivateRoute>} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/admin" element={<PrivateRoute><Admin /></PrivateRoute>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
